document.addEventListener("DOMContentLoaded", function () {
  const tabs = document.querySelectorAll("ul.tabs li");
  const contents = document.querySelectorAll(".tab-content");

  tabs.forEach(tab => {
    tab.addEventListener("click", function () {
      const tab_id = this.getAttribute("data-tab");

      // Remove 'current' from all
      tabs.forEach(t => t.classList.remove("current"));
      contents.forEach(c => c.classList.remove("current"));

      // Add 'current' to clicked tab + content
      this.classList.add("current");
      document.getElementById(tab_id).classList.add("current");
    });
  });
});


// product group panel
document.addEventListener("DOMContentLoaded", function() {
  // Select all panel headings inside panel items
  const panels = document.querySelectorAll(".onyx-panelgroup .panelitem .panelheading");
  panels.forEach(panel => {
    panel.addEventListener("click", function(e) {
      e.preventDefault();
      const content = this.nextElementSibling;
      const isActive = this.classList.contains("active");
      // Close all panels
      panels.forEach(p => {
        p.classList.remove("active");
        const icon = p.querySelector("i");
        if (icon) {
          icon.classList.remove("fa-minus");
          icon.classList.add("fa-plus");
        }
        const panelContent = p.nextElementSibling;
        if (panelContent) {
          panelContent.style.maxHeight = null;
        }
      });
      // Open clicked panel if it was not active
      if (!isActive) {
        this.classList.add("active");
        const icon = this.querySelector("i");
        if (icon) {
          icon.classList.remove("fa-plus");
          icon.classList.add("fa-minus");
        }
        if (content) {
          content.style.maxHeight = content.scrollHeight + "px";
        }
      }
    });
  });
});